import React from 'react';
import PropTypes from 'prop-types';

const ParagraphDynamic = props => {
    return (
        <section className="dynamic">
            Dynamic {props.r.component.name} here
        </section>
    );
};

ParagraphDynamic.propTypes = {
    /** Entity References */
    r: PropTypes.shape({
        component: PropTypes.shape({
            name: PropTypes.string,
        }),
    }),
};

export default ParagraphDynamic;
